/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HazardCurrentPrecautionDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: HazardCurrentPrecautionDefinitionDto.source;
    label?: string;
}

export namespace HazardCurrentPrecautionDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
